export default {
    entity: 'Template',
    name: 'Name',
    termsheetType: 'Termsheet Type',
    createdAt: 'Created At',
    updatedAt: 'Last Updated',
    noData: 'No templates',
};
